import type { AxiosError } from 'axios';
import { createMutation } from 'react-query-kit';

import { client } from '../common';

type Variables = { authCode: string };
export type ConnectInsuranceSessionResponse = {};

export const useConnectInsuranceSession = createMutation<
  ConnectInsuranceSessionResponse,
  Variables,
  AxiosError
>({
  mutationFn: async (variables) =>
    client({
      url: 'v2/customers/insurance/connect',
      method: 'POST',
      data: {
        auth_code: variables.authCode,
      },
    })
      .then((response) => response.data)
      .catch((err: any) => {
        throw new Error(err.response.data.errors.join(', '));
      }),
});
